export default "__VITE_ASSET__BOT4nLTa__"